/**
 * Illegal Lashes — Sticky Add to Cart
 * Reveals when the real add-to-cart button scrolls out of view, posts to the
 * SAME product form (no duplicate cart logic), and mirrors the currently
 * selected variant's label/price from the existing DOM.
 */
(function () {
  function init() {
    var bar = document.querySelector('[data-il-sticky-atc]');
    if (!bar) return;

    var form = document.querySelector('form[data-type="add-to-cart-form"]');
    var mainSubmit = form ? form.querySelector('button[type="submit"][name="add"]') : null;
    var stickySubmit = bar.querySelector('[data-il-sticky-submit]');

    // Read the id ATTRIBUTE, not the .id property: this form has a hidden
    // input named "id" (variant id), which shadows the native .id IDL
    // property per the HTMLFormElement named-getter spec quirk.
    var formId = form.getAttribute('id');
    if (!form || !mainSubmit || !stickySubmit || !formId) return;

    // Point the sticky button at the real form. One add-to-cart code path.
    stickySubmit.setAttribute('form', formId);

    // Keep the bar above the mobile bottom toolbar.
    var offset = parseInt(bar.dataset.mobileOffset, 10) || 0;
    var mq = window.matchMedia('(max-width: 767px)');
    function applyOffset() {
      bar.style.setProperty('--il-atc-offset', mq.matches ? offset + 'px' : '0px');
    }
    applyOffset();
    mq.addEventListener ? mq.addEventListener('change', applyOffset) : window.addEventListener('resize', applyOffset);

    // Reveal once the real button scrolls out of view above the fold.
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        bar.classList.toggle('show', !entry.isIntersecting && entry.boundingClientRect.top < 0);
      });
    }, { threshold: 0 });
    io.observe(mainSubmit);

    // Mirror variant label + price after the theme's own variant update lands.
    var variantSelects = document.querySelector('variant-selects');
    function syncFromDom() {
      var labelEl = bar.querySelector('[data-il-variant-label]');
      var priceEl = bar.querySelector('[data-il-price]');

      var checked = document.querySelectorAll('.swatchInput:checked');
      if (labelEl && checked.length) {
        var labels = Array.prototype.map
          .call(checked, function (input) {
            var lbl = document.querySelector('label[for="' + input.id + '"]');
            return lbl ? lbl.textContent.trim() : '';
          })
          .filter(Boolean);
        if (labels.length) labelEl.textContent = labels.join(' · ').toUpperCase();
      }

      var priceSource = document.querySelector('[id^="ProductPrice-"]');
      if (priceEl && priceSource && priceSource.textContent.trim()) {
        priceEl.textContent = priceSource.textContent.trim();
      }

      var soldOut = mainSubmit.hasAttribute('disabled');
      stickySubmit.disabled = soldOut;
    }

    if (variantSelects) {
      variantSelects.addEventListener('change', function () {
        // The theme updates price/availability via its own async Section
        // Rendering fetch; give it a moment to land before we mirror it.
        setTimeout(syncFromDom, 400);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
